import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
} from 'react';
import { Modal, View, Text, StyleSheet, Pressable } from 'react-native';

type ErrorContextType = {
  showError: (msg: string) => void;
};

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export const useGlobalError = () => {
  const ctx = useContext(ErrorContext);
  if (!ctx) throw new Error('useGlobalError must be inside GlobalErrorProvider');
  return ctx;
};

interface Props {
  children: ReactNode;
}

export function GlobalErrorProvider({ children }: Props) {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');

  // expose showError without needing navigate yet
  const showError = (msg: string) => {
    console.log('GlobalErrorProvider showError called with:', msg);
    setMessage(msg);
    setVisible(true);
  };

  return (
    <ErrorContext.Provider value={{ showError }}>
      {children}
      {visible && <ErrorModal message={message} onClose={() => setVisible(false)} />}
    </ErrorContext.Provider>
  );
}

// separate component so useNavigate is only called inside BrowserRouter
function ErrorModal({
  message,
  onClose,
}: {
  message: string;
  onClose: () => void;
}) {
  const handleOk = () => {
    onClose();
  };

  return (
  <View style={styles.overlay}>
    <View style={styles.box}>
      <Text style={styles.title}>Error</Text>
      <Text style={styles.message}>{message}</Text>
      <Pressable style={styles.button} onPress={handleOk}>
        <Text style={styles.buttonText}>OK</Text>
      </Pressable>
    </View>
  </View>
    // <Modal transparent animationType="fade" visible>
    //   <View style={styles.overlay}>
    //     <View style={styles.box}>
    //       <Text style={styles.title}>Error</Text>
    //       <Text style={styles.message}>{message}</Text>
    //       <Pressable style={styles.button} onPress={handleOk}>
    //         <Text style={styles.buttonText}>OK</Text>
    //       </Pressable>
    //     </View>
    //   </View>
    // </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: {
position: 'absolute',   // fixed is best for web
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0,0,0,0.5)',
  zIndex: 99999,
  },
//   overlay: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     justifyContent: 'center',
//     alignItems: 'center',
//     backgroundColor: 'rgba(0,0,0,0.5)',
//     zIndex: 99999,
//     elevation: 99999,
//     pointerEvents: 'auto',  // ensure clicks go to modal
//   },
  box: {
    width: '80%',
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 20,
  },
  title: { fontSize: 18, fontWeight: '600', marginBottom: 8 },
  message: { fontSize: 16, marginBottom: 20 },
  button: {
    alignSelf: 'flex-end',
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: '#000',
    borderRadius: 8,
  },
  buttonText: { color: '#fff', fontWeight: '600' },
});
